export default {"src":"/_next/static/media/DOC.bbe13751.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};